import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import {t} from 'i18next';
import {isEmpty} from 'lodash';
import {ReactNode} from 'react';
import {NavigateFunction} from 'react-router-dom';

const LOGOUT_DELAY = 2500;
const CALLBACK_DELAY = 2500;

export const redirectAfterCallback = (
  navigate: NavigateFunction,
  _userKind: number
) => {
  const params = new URLSearchParams(window.location.search);
  const redirectData = params.get('redirect_data');
  setTimeout(() => {
    if (isEmpty(redirectData)) {
      localStorage.setItem('currentLink', '/welcome-multi-client');
      navigate('/welcome-multi-client');
    } else {
      navigate(`/deep-link?redirect_data=${redirectData}`);
    }
  }, CALLBACK_DELAY);
};

export const redirectAfterLogout = (navigate: NavigateFunction) => {
  setTimeout(() => {
    navigate('/login', {
      replace: true,
    });
  }, LOGOUT_DELAY);
};

export const AuthPageLayout = ({children}: {children: ReactNode}) => {
  return (
    <Box className="login-bg-color">
      <Container maxWidth={false} className="login-page">
        <Grid container>
          <LeftPaneBrand />
          <Grid item xs={6} md={6}>
            {children}
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export const LeftPaneBrand = () => {
  return (
    <Grid item xs={6} md={6} className="logo">
      <Box className={'logo-text-container'}>
        <Box className={'title-subtitle-container'}>
          <Typography className="typo-text display1_size mist-color app-logo-text">
            {t('app.logoNameTitle')}
          </Typography>
          <Box className={'img-subtitle-container'}>
            <img src="/assests/images/by_consilio.svg" alt="By Consilio" aria-hidden="true" />
          </Box>
        </Box>
        <img src="/assests/images/consilio_logo.svg" alt="Consilio Logo" aria-hidden="true" />
      </Box>
    </Grid>
  );
};
